/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Save_Project_AsInputs */

const en_save_project_as = /** @type {(inputs: Save_Project_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Project As...`)
};

const fr_save_project_as = /** @type {(inputs: Save_Project_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer le projet sous...`)
};

const de_save_project_as = /** @type {(inputs: Save_Project_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt speichern unter...`)
};

const it_save_project_as = /** @type {(inputs: Save_Project_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva progetto con nome...`)
};

const ru_save_project_as = /** @type {(inputs: Save_Project_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранить проект как...`)
};

const es_save_project_as = /** @type {(inputs: Save_Project_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar proyecto como...`)
};

const zh_cn2_save_project_as = /** @type {(inputs: Save_Project_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将项目另存为...`)
};

const ja_save_project_as = /** @type {(inputs: Save_Project_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトに名前を付けて保存...`)
};

const hi_save_project_as = /** @type {(inputs: Save_Project_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`के रूप में इस परियोजना को बचाओ...`)
};

const pt_pt2_save_project_as = /** @type {(inputs: Save_Project_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar projeto como...`)
};

/**
* | output |
* | --- |
* | "Save Project As..." |
*
* @param {Save_Project_AsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const save_project_as = /** @type {((inputs?: Save_Project_AsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Save_Project_AsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_save_project_as(inputs)
	if (locale === "de") return de_save_project_as(inputs)
	if (locale === "it") return it_save_project_as(inputs)
	if (locale === "ru") return ru_save_project_as(inputs)
	if (locale === "es") return es_save_project_as(inputs)
	if (locale === "zh-CN") return zh_cn2_save_project_as(inputs)
	if (locale === "ja") return ja_save_project_as(inputs)
	if (locale === "hi") return hi_save_project_as(inputs)
	if (locale === "pt-PT") return pt_pt2_save_project_as(inputs)
	return en_save_project_as(inputs)
});